import { render, staticRenderFns } from "./TaskCommit.vue?vue&type=template&id=092d01e4&scoped=true"
import script from "./TaskCommit.vue?vue&type=script&lang=js"
export * from "./TaskCommit.vue?vue&type=script&lang=js"
import style0 from "./TaskCommit.vue?vue&type=style&index=0&id=092d01e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d01e4",
  null
  
)

export default component.exports